import { WalletClientWithAccount } from '@vertex-protocol/client';
import { Account, Chain, createWalletClient, http } from 'viem';

export function getWalletClientForLinkedSignerAccount(
  account: Account,
  chain: Chain,
): WalletClientWithAccount {
  return createWalletClient({
    account,
    transport: http(getChainRpcUrl(chain)),
    chain,
  });
}

function getChainRpcUrl(chain: Chain): string | undefined {
  return chain.rpcUrls.default.http[0] ?? chain.rpcUrls.public?.http[0];
}
